import React from 'react'
import PropTypes from 'prop-types'
import Tag from "@ramsey-design-system/tag";

const TagList = ({ tags, activeTag, onTagSelected = () => {} }) => {

  const handleTagClicked = (event) => {
    onTagSelected(event.target.textContent)
  }

  return tags.map((tag) => <Tag text={tag} color="primary" subtle={tag !== activeTag} onClick={handleTagClicked} className="m-1" key={tag} />)
}

TagList.propTypes = {
  tags: PropTypes.array,
  activeTag: PropTypes.string,
  onTagSelected: PropTypes.func
}

export default TagList
